// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"02f46e99","128":"4ac3f6bf","240":"b3086058","241":"4bfc4cf7","505":"0acafd4a","696":"226f9d6e","805":"95d1d089","885":"2eb87555","996":"7ba6cddc"}[chunkId] + ".chunk.js";
};